<template>
  <div class="competitor-info-wrap">
    <MenuSide
      ref="menuSide"
      :sideCode="sideCode"
      :searchParams="searchParams"
      :filterItemConfig="filterItemConfig"
      @filter="handlerFilter"
      @exclude="handlerExclude"
      @resetConfig="handlerSwitch"
      @clearCardItem="handlerClearCardItem"
      @resetSideMenu="handlerResetSideMenu"></MenuSide>
    <ResultList
      ref="resultList"
      :searchParams="searchParams"
      :familySettingDefaultValue="familySettingDefaultValue"
      @familySelectChange="familySelectClassify"
      @timingChange="timingChange"
      @ok="handlerFamilyModalOk"
    ></ResultList>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import MenuSide from './components/MenuSide'
import ResultList from './components/ResultList'
import { filterItemConfig } from './configs'

export default {
  data() {
    return {
      filterItemConfig, // 配置
      // 侧边栏企业名录的选中参数
      sideCode: {},
      // 检索参数
      searchParams: { // 检索的参数配置
        modelId: '75c3b76f-1cb9-11eb-b1c6-70106fc9fcee',
        // mergeType: 0, // 合并类型
        requestCols: [], // 请求的cols
        expreType: 1, // 检索类型 1: 检索式 or 2: 筛选
        search: false, // 是否属于检索式搜索
        searchNew: false, // 不知道做啥的
        translation: false, // ?
        searchExpre: ''
      },
      // 同族设置的默认值
      familySettingDefaultValue: {
        publicOrder: 1,
        timeOrder: 'publicOrder-1',
        mergeType: 2
      },
    }
  },
  components: {
    MenuSide,
    ResultList
  },
  watch: {
    getSearchExper(nVal) {
      this.initSearchParams(nVal)
    }
  },
  computed: {
    ...mapGetters('filterGroup', [
      'getSearchExper'
    ])
  },
  methods: {
    ...mapMutations('filterGroup', [
      'filterOrExcludeExpHandler',
      'clearTempFilterItem',
      'clearFilterAndExcludeExp',
      'clearHasSearchMap',
      'resetAllSetting'
    ]),
    // 重置searchParams
    initSearchParams(nVal) {
      const [key, v] = this.$refs.resultList.select1.defaultValue.split('-')
      this.searchParams.requestCols = [{ alias:key, sortType: v }]
      this.searchParams.searchExpre = nVal
      // console.log(this.searchParams, '最新的检索式')
    },
    // 筛选
    handlerFilter() {
      this.filterOrExcludeExpHandler('filter')
      this.resetConfig()
    },
    // 过滤
    handlerExclude() {
      this.filterOrExcludeExpHandler('exclude')
      this.resetConfig()
    },
    // 处理企业名录和筛选的切换
    handlerSwitch() {
      this.resetConfig()
    },
    // 重置配置
    resetConfig() {
      this.filterItemConfig.forEach((item) => {
        item.list = []
        item.currentIndex = 0
        item.noticText = ''
        item.pageSize = 20
        item.open = false
        item.hasRequest = false
        item.nextPage = true
        item.page = 1
      })
      this.clearTempFilterItem() // 清空勾选缓存检索式
      this.clearHasSearchMap() // 清空请求记录表
    },
    // 重置侧边菜单栏的配置
    handlerResetSideMenu() {
      this.resetConfig() // 重置菜单配置
      this.clearTempFilterItem() // 清空勾选缓存检索式
      this.clearFilterAndExcludeExp() // 清空检索式处理结果
      this.resetAllSetting() // 重置筛选卡片的样式
    },
    // 单独删除某个
    handlerClearCardItem() {
      this.resetConfig() // 重置菜单配置
    },
    // 时机筛选
    timingChange(v) {
      const [key, value] = v.split('-')
      this.searchParams.requestCols = [{ alias:key, sortType: value }]
    },
    // 处理同族弹窗的确认回调
    handlerFamilyModalOk(familySettingValue) {
      this.familySetting = familySettingValue
      const ref = this.$refs.resultList
      const type = ref.select2.defaultValue // 获取当前选中的类型
      this.familySelectClassify(type)
    },
    // 分类不同的同族的参数
    familySelectClassify(type){
      const baseSearchParams = {...this.searchParams}
      const {publicOrder, timeOrder, mergeType, countryOrder} = this.familySetting || this.familySettingDefaultValue
      if(type === 1) {  // 申请号合并
        baseSearchParams.publicOrder = publicOrder
        baseSearchParams.mergeType = 1
      } else if(type === 2) { // 同族号
        const [key, v] = timeOrder.split('-')
        baseSearchParams.countryOrder = countryOrder
        baseSearchParams[key] = Number(v)
        baseSearchParams.mergeType = mergeType
      }
      this.searchParams = {...baseSearchParams}
    }
  }
}
</script>
